<div class="img__background">
  <img class="img__container" [src]="src" [alt]="alt" />
</div>
